import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/x-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-a2da6e32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "required"
}
const _hoisted_4 = ["id", "name", "type", "placeholder", "disabled", "maxlength", "inputmode", "readonly", "onBlur"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: $props.name
        }, [
          _createElementVNode("span", null, _toDisplayString($props.label), 1 /* TEXT */),
          ($props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["Field"], {
      name: $props.name,
      type: $props.type,
      modelValue: $setup.inputValue,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.inputValue) = $event)),
      rules: $props.rules
    }, {
      default: _withCtx(({ errorMessage: validationErrorMessage, handleBlur, meta }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["text-input", {
          error: $props.errorMessage || (meta.touched && validationErrorMessage),
          disabled: $props.disabled,
          readonly: $props.readonly,
        }])
        }, [
          _withDirectives(_createElementVNode("input", {
            ref: "inputField",
            class: "input--base wizdome-custom",
            id: $props.name,
            name: $props.name,
            type: $props.type,
            placeholder: $props.placeholder,
            disabled: $props.disabled,
            maxlength: $props.maxlength,
            inputmode: $props.inputmode,
            readonly: $props.readonly,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputValue) = $event)),
            onInput: $setup.onInput,
            onChange: $setup.onChange,
            onFocus: $setup.onFocused,
            onBlur: ($event: any) => ([handleBlur(), $setup.onBlurred()])
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4), [
            [
              _vModelDynamic,
              $setup.inputValue,
              void 0,
              { trim: true }
            ]
          ]),
          _withDirectives(_createElementVNode("img", {
            class: "img-clear-text",
            role: "button",
            "aria-label": "텍스트 지우기",
            src: _imports_0,
            onClick: $setup.clearText,
            onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
            [_vShow, $props.enableClearText && $setup.shouldShowClearButton]
          ]),
          _renderSlot(_ctx.$slots, "inputInnerButton", {
            valid: meta.valid
          }, undefined, true)
        ], 2 /* CLASS */),
        _withDirectives(_createElementVNode("p", { class: "message success" }, _toDisplayString($props.successMessage), 513 /* TEXT, NEED_PATCH */), [
          [_vShow, $props.successMessage]
        ]),
        _withDirectives(_createElementVNode("p", { class: "message error" }, _toDisplayString($props.errorMessage || validationErrorMessage), 513 /* TEXT, NEED_PATCH */), [
          [_vShow, $props.errorMessage || (meta.touched && validationErrorMessage)]
        ])
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["name", "type", "modelValue", "rules"])
  ]))
}